import type { ReactNode, SyntheticEvent } from 'react';
import { makeStyles } from 'tss-react/mui';
import { ToggleButton, ToggleButtonGroup } from '@mui/material';
import SectionHeader from '../section-header';

const useStyles = makeStyles()((theme) => ({
  grid: {
    marginTop: theme.spacing(3),
  },
}));

type Props = {
  view: 'upcoming' | 'past';
  hostedEventsCount: number;
  pastHostedEventsCount: number;
  onChange: (e: SyntheticEvent, value: 'upcoming' | 'past' | null) => void;
  children?: ReactNode;
};

const UserEventsGrid = ({ view, hostedEventsCount, pastHostedEventsCount, onChange, children }: Props) => {
  const { classes } = useStyles();

  return (
    <div className={classes.grid}>
      <SectionHeader
        sx={{ mt: 0, mb: 1 }}
        action={
          <ToggleButtonGroup value={view} exclusive size="small" onChange={onChange}>
            <ToggleButton value="upcoming">
              Upcoming ({hostedEventsCount})
            </ToggleButton>
            <ToggleButton value="past">
              Past ({pastHostedEventsCount})
            </ToggleButton>
          </ToggleButtonGroup>
        }
      >
        {view === 'past' ? 'Past' : 'Upcoming'}
      </SectionHeader>
      {children}
    </div>
  );
};

export default UserEventsGrid;
